var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleAngleRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.229455 0.730993C-0.0764847 1.03898 -0.0764847 1.53834 0.229455 1.84633L3.36213 5L0.229455 8.15367C-0.0764847 8.46166 -0.0764847 8.96102 0.229455 9.26901C0.535396 9.577 1.03142 9.577 1.33736 9.26901L5.02399 5.55767C5.32993 5.24968 5.32993 4.75032 5.02399 4.44233L1.33736 0.730993C1.03142 0.423002 0.535396 0.423002 0.229455 0.730993Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97601 0.730993C4.67007 1.03898 4.67007 1.53834 4.97601 1.84633L8.10868 5L4.97601 8.15367C4.67007 8.46166 4.67007 8.96102 4.97601 9.26901C5.28195 9.577 5.77798 9.577 6.08392 9.26901L9.77055 5.55767C10.0765 5.24968 10.0765 4.75032 9.77055 4.44233L6.08392 0.730993C5.77798 0.423002 5.28195 0.423002 4.97601 0.730993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleAngleRight);
export default __webpack_public_path__ + "static/media/double-angle-right.46314fdfadca4742d29a172a96e9930a.svg";
export { ForwardRef as ReactComponent };